module.exports = __webpack_public_path__ + "media/images/games/no-game/rectangle-2fef9547e809cbd3b0d386c057eea8b2.jpg";